<template>
  <a :href="url">
      {{text}}
  </a>
</template>

<script>
export default {
  name: 'custom-link',
  props: {
    text: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang='scss'>
@import '../assets/variables';

a {
  color: $brand-primary;
  font-family: 'OpenSansBold';
  text-decoration: none;
}

a:hover {
  color: $brand-highlight;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomLink.vue